import { render, staticRenderFns } from "./SideCard.vue?vue&type=template&id=2079367a&scoped=true"
import script from "./SideCard.vue?vue&type=script&lang=js"
export * from "./SideCard.vue?vue&type=script&lang=js"
import style0 from "./SideCard.vue?vue&type=style&index=0&id=2079367a&prod&scoped=true&lang=css"
import style1 from "./SideCard.vue?vue&type=style&index=1&id=2079367a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079367a",
  null
  
)

export default component.exports